import { useState } from "react";
import { Box, Button, IconButton, TextField, Typography } from "@mui/material";
import { makeSxStyles } from "ui";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { isEmpty } from "lodash";
import { useAdminAccountControllerResetPassword } from "service";
import { toast } from "react-toastify";

// Tab 2 of the Settings screen (ESR-1616) - ported as-is from the old
// standalone update-password-page.tsx (same logic, same validation), just
// without the page-level DashboardContentLayout wrapper since SettingsPage
// provides that shell now.
const ChangePasswordTab = () => {
  const styles = useStyles();
  const { mutate, isLoading } = useAdminAccountControllerResetPassword({
    onSuccess: () => {
      toast.success("Password Updated Successfully");
      setNewPassword1("");
      setNewPassword2("");
      setOldPassword("");
    },
  });
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [oldPassword, setOldPassword] = useState<string>("");
  const [newPassword1, setNewPassword1] = useState<string>("");
  const [newPassword2, setNewPassword2] = useState<string>("");

  const passwordsMatch =
    newPassword1 === newPassword2 && !isEmpty(newPassword1);
  const sufficientLength = newPassword1.length > 7;

  const onUpdatePassword = () => {
    mutate({
      body: {
        oldPassword,
        newPassword: newPassword1,
      },
    });
  };

  return (
    <Box sx={styles.customerDetailContainer}>
      <Typography fontWeight={600}>Current Password</Typography>
      <TextField
        value={oldPassword}
        onChange={(e) => setOldPassword(e.target.value)}
        type={showPassword ? "text" : "password"}
        InputProps={{
          endAdornment: (
            <IconButton
              sx={styles.iconButton}
              onClick={() => setShowPassword((prev) => !prev)}
            >
              {showPassword ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          ),
        }}
      />
      <Typography fontWeight={600}>New Password</Typography>
      <TextField
        value={newPassword1}
        onChange={(e) => setNewPassword1(e.target.value)}
        type={showPassword ? "text" : "password"}
      />
      <Typography fontWeight={600}>Repeat New Password</Typography>
      <Box>
        <TextField
          value={newPassword2}
          onChange={(e) => setNewPassword2(e.target.value)}
          type={showPassword ? "text" : "password"}
          fullWidth
        />
        <ul>
          <li>
            <Typography color={!isEmpty(oldPassword) ? "primary" : "neutral"}>
              Old password is required.
            </Typography>
          </li>
          <li>
            <Typography color={!isEmpty(newPassword1) ? "primary" : "neutral"}>
              New password is required.
            </Typography>
          </li>
          <li>
            <Typography color={passwordsMatch ? "primary" : "neutral"}>
              Passwords must match.
            </Typography>
          </li>
          <li>
            <Typography color={sufficientLength ? "primary" : "neutral"}>
              New password must be at least 8 characters long.
            </Typography>
          </li>
        </ul>
      </Box>
      <Button
        onClick={onUpdatePassword}
        variant="contained"
        sx={styles.updatePasswordButton}
        disabled={
          isEmpty(oldPassword) ||
          isEmpty(newPassword1) ||
          !passwordsMatch ||
          !sufficientLength ||
          isLoading
        }
      >
        Update password
      </Button>
    </Box>
  );
};

const useStyles = makeSxStyles(() => ({
  customerDetailContainer: {
    mt: "40px",
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    rowGap: "16px",
    maxWidth: "50%",
  },
  updatePasswordButton: {
    gridColumn: 2,
    ml: "auto",
  },
}));

export default ChangePasswordTab;
